export default __webpack_public_path__ + "static/media/logo.7c604e5d.webp";